<script lang="ts" setup>
import { computed, ref, toRef, watch } from 'vue';
import Select from './Select.vue';
import { computedAsync, toRefs } from '@vueuse/core';
import adminAPI from '@/services/api';

const props = defineProps<{ selectedCourtId?: number }>();
const selectedCourtId = toRef(props, "selectedCourtId")

const isLoading = ref(true);
const courts = computedAsync(async () => {
  const allCourts = await adminAPI.listAllCourts();
  

  options.value = options.value.concat(
    allCourts.map((c) => ({ label: c.name, value: c.id }))
  );

  const selectedIndex = options.value.findIndex(({ value }) => value === selectedCourtId.value);
  selectedOptionIndex.value = selectedIndex === -1 ? 0 : selectedIndex;

  return allCourts;
}, null, isLoading);

const options = ref<Array<{ value: number; label: string; }>>([{ label: "Aucun", value: null as any }]);

const selectedOptionIndex = ref(0);
</script>
<template>
  <div class="text-left cursor-pointer">

    <Select v-if="!isLoading" @update:modelValue="(value) => $emit('update:modelValue', value as any)"
      label="Tribunal compétent"
      :options="options"
      :selected-option="selectedOptionIndex"
    />
  </div>
</template>